import { api } from "../api";
import { isAxiosError } from "axios";

// Carrinho v2: linhas por produto + combinação, preço da combinação, cada
// linha endereçada pelo `lineId` que o GET devolve.

/* ================================
   LISTAR CARRINHO
================================ */

export async function listarCarrinho() {
  try {
    const response = await api.get("/v2/cart");

    return response.data;
  } catch (error) {
    console.error("Erro ao listar carrinho:", error);

    if (isAxiosError(error)) {
      console.error("STATUS:", error.response?.status);
      console.error("BODY:", error.response?.data);
    }

    throw error;
  }
}

/* ================================
   ADICIONAR ITEM
================================ */

export async function adicionarItemCarrinho(
  productId: string,
  quantity: number,
  combinationId: string | null = null,
) {
  try {

    const response = await api.post("/v2/cart", {
      productId,
      quantity,
      ...(combinationId ? { combinationId } : {}),
    });


    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar item:", error);

    if (isAxiosError(error)) {
      console.error("STATUS:", error.response?.status);
      console.error("BODY:", error.response?.data);
    }

    throw error;
  }
}

/* ================================
   ALTERAR QUANTIDADE
================================ */

export async function alterarQuantidadeCarrinho(
  lineId: string,
  quantity: number,
) {
  try {

    const response = await api.patch(
      `/v2/cart/items/${lineId}`,
      {
        quantity,
      },
    );


    return response.data;
  } catch (error) {
    console.error("Erro ao alterar quantidade:", error);

    if (isAxiosError(error)) {
      console.error("STATUS:", error.response?.status);
      console.error("BODY:", error.response?.data);
    }

    throw error;
  }
}

/* ================================
   REMOVER ITEM
================================ */

export async function removerItemCarrinho(
  lineId: string,
) {
  try {

    const response = await api.delete(
      `/v2/cart/items/${lineId}`,
    );


    return response.data;
  } catch (error) {
    console.error("Erro ao remover item:", error);

    if (isAxiosError(error)) {
      console.error("STATUS:", error.response?.status);
      console.error("BODY:", error.response?.data);
    }

    throw error;
  }
}

/* ================================
   LIMPAR CARRINHO
================================ */

export async function limparCarrinho() {
  try {

    const response = await api.delete("/v2/cart");


    return response.data;
  } catch (error) {
    console.error("Erro ao limpar carrinho:", error);

    if (isAxiosError(error)) {
      console.error("STATUS:", error.response?.status);
      console.error("BODY:", error.response?.data);
    }

    throw error;
  }
}